import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { withRouter } from "react-router";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import {
  getMerchantVoucherList,
  updateStatus,
  getMerchantDeals,
  getMerchantAllVoucherList
} from "../../../redux/actions/voucherActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { CSVLink } from "react-csv";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import auth from "../../../services/auth";

const history = createBrowserHistory();

let isLoading = "false",
  headers = [],
  userID = "";
class List extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      voucherData: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Manage Tracking Numbers"],
      show: false,
      voucherNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      userNameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      statusSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      trackingNumberSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      direction: "",
      orderBy: "",
      showDialog: false,
      promoid: "",
      show: false,
      deallist: [],
      dealID: "",
      defaultdealID: "",
      merchantName: "",
      expirationMonth: "",
      merchantDetails: [],

      exceldata: [
        {
          voucherNumber: "",
          userName: "",
          dealText: "",
          status: "",
          createdOn: "",
          redeemed_at: ""
        }
      ]
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : "",
      dealID: this.state.dealID
    };
    this.props.getMerchantVoucherList(postData);
  };

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getMerchantVoucherList({
      orderBy: orderBy,
      direction: direction,
      dealID: this.state.dealID,
      limit: this.state.limit 
    });
  };

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID, {page: 0});
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id, {page: 0});
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantVoucherList !== nextProps.merchantVoucherList) {
      if (nextProps.merchantVoucherList) {
        isLoading = "false";
        const setPageCount =
          nextProps.merchantVoucherList.data.total /
          nextProps.merchantVoucherList.data.per_page;
        this.setState({
          voucherData: nextProps.merchantVoucherList.data.data,
          totalRecords: nextProps.merchantVoucherList.data.total,
          perPage: nextProps.merchantVoucherList.data.per_page,
          pageCount: setPageCount
        });
        let merchantDetails = [];
        let merchantData = nextProps.merchantVoucherList.data.data
          ? nextProps.merchantVoucherList.data.data
          : [];
        if (merchantData) {
          merchantData.map((merchant, index) => {
            merchantDetails.push({
              voucherNumber: merchant.voucherNumber,
              userName: merchant.userName,
              dealText: merchant.dealText,
              status: merchant.status,
              createdOn: merchant.createdOn,
              redeemed_at: merchant.redeemed_at
            });
          });
          this.setState({ exceldata: merchantDetails });
        }
      }
    }

    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data });
      }
    }

    if (this.props.voucherStatus !== nextProps.voucherStatus) {
      if (nextProps.voucherStatus) {
        this.props.clearAlert();
        this.handleShow();

        if (nextProps.voucherStatus.message) {
          isLoading = "false";
          this.props.getVoucherList();
          this.props.renderAlert("success", nextProps.voucherStatus.message);
        }
      }
    }
    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  changeStatus = (voucherID, status) => {
    this.handleShow();
    isLoading = "true";
    let postdata = {
      status: status
    };
    this.props.updateStatus(voucherID, postdata);
  };

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring,
      dealID: this.state.dealID
    };
    if (this.state.search.length !== 0) {
      this.props.getMerchantVoucherList(postData);
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    let postData = {
      dealID: e.target.value,
      limit: this.state.limit 
    };
    if (e.target.value !== "") {
      isLoading = "true";
      this.props.getMerchantVoucherList(postData);

      const selectedMerchant = this.state.deallist.find(
        k => k.dealID == e.target.value
      );
      this.setState({ merchantName: selectedMerchant.merchantName });
      this.setState({ expirationMonth: selectedMerchant.expirationMonth });

      let allData = {
        dealID: e.target.value,
        page: 0
      };
    }
  }

  render() {
    let dealListItems;
    let dealListData = this.state.deallist ? this.state.deallist : [];
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID}>
          {el.dealText}
        </option>
      ));
    }

    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let voucherRow;
    let voucherListData =
      this.state.voucherData.length > 0 ? this.state.voucherData : "";
    if (!isEmpty(voucherListData) && this.state.dealID !== "") {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.trackingNumber}</td>
          <td>{voucher.createdOn} </td>
          <td> {voucher.trackingUploadedAt} </td>
        </tr>
      ));
    } else {
      voucherRow = (
        <tr>
          <td>
            {" "}
            <span style={{ color: "red" }}>
              No tracking numbers uploaded for this offer vouchers!{" "}
            </span>{" "}
          </td>
        </tr>
      );
    }

    headers = [
      { label: "Voucher Number", key: "voucherNumber" },
      { label: "Purchaser", key: "userName" },
      { label: "Offer", key: "dealText" },
      { label: "Voucher Status", key: "status" },
      { label: "Purchase Timestamp", key: "createdOn" },
      { label: "Redeemed At", key: "redeemed_at" }
    ];

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-right">
              <Button
                bsSize="small"
                bsStyle="success"
                onClick={() => this.context.router.history.push(`/merchant/dashboard/${userID}`)}
              >
                Back
              </Button>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              {" "}
              Voucher Tracking Numbers List{" "}
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}

              <div className="row">
                <div className="col-lg-12 text-left">
                  <FormGroup controlId="formdeallist">
                    <ControlLabel>{this.state.merchantName}</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealID"
                      onChange={this.handleChange}
                      value={this.state.dealID}
                    >
                      <option value="">Select your offer</option>
                      {dealListItems}
                    </FormControl>
                  </FormGroup>
                </div>
              </div>
              {this.state.dealID !== "" ? (
                <div className="row">
                  <div className="col-lg-12 text-right">
                    {userID !== "" ? (
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          this.context.router.history.push(
                            `/upload/trackingnumbers/${
                              this.state.dealID
                            }/${userID}`
                          )
                        }
                      >
                        Upload Tracking Numbers
                      </Button>
                    ) : (
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          this.context.router.history.push(
                            `/upload/trackingnumbers/${this.state.dealID}`
                          )
                        }
                      >
                        Upload Tracking Numbers
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onChange={this.handleSearch}
                      />
                      <InputGroup.Addon>
                        <i className="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("voucherNumber")}>
                          Voucher Number{" "}
                          <span
                            className={this.state.voucherNumberSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>
                        <th onClick={this.handleSort("trackingNumber")}>
                          Tracking Number{" "}
                          <span
                            className={this.state.trackingNumberSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>
                        <th>Purchased At </th>
                        <th>Tracking Uploaded At</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>{voucherRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantdealList: state.voucherReducer.merchantdealList,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  merchantVoucherList: state.voucherReducer.merchantVoucherList,
  voucherStatus: state.voucherReducer.voucherStatus,
  merchantAllVouchers: state.voucherReducer.merchantAllVouchers
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    updateStatus,
    getMerchantVoucherList,
    getMerchantAllVoucherList,
    getMerchantDeals
  })
)(List);




// WEBPACK FOOTER //
// ./src/app/views/merchant/trackingNumbers/List.js